import React, { useEffect, useState, useRef } from 'react';
import { Container, Form, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import FileDownload from '../../../../icons/file-download.svg';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import FileTable from '../../../Product/SharedComponents/SubComponents/FileTable';
import { format } from 'date-fns-tz';
import { httpRequest } from '../../../../httpRequest';
import '../../../Common/ScheduleAppointment/ScheduleAppointment.scss';
import BackNextButton from '../../../Common/BackNextButton';
import TitleComponent from '../../../Common/TitleComponent';
import { object, string } from 'yup';
import { SelectInput } from '../../../Helpers/Inputs';

const useStyles = makeStyles((theme) => ({
    buttonReplace: {
        color: theme.palette.primary.main,
        cursor: 'pointer',
    },
    disabledButtonSelect: {
        color: 'rgba(0, 0, 0, 0.26)',
        boxShadow: 'none',
        backgroundColor: 'rgba(0, 0, 0, 0.12)',
        cursor: 'pointer',
        padding: '6px 16px',
        fontSize: '0.875rem',
        boxSizing: 'border-box',
        fontWeight: '500',
        lineHeight: '1.75',
        borderRadius: '4px',
        width: '100%',
        textAlign: 'center'
    },
    buttonSelect: {
        color: theme.palette.primary.main,
        border: ' 1px solid rgba(48, 67, 147, 0.5)',
        boxShadow: '0px 2px 4px 0px lightgrey',
        backgroundColor: 'rgba(255, 255, 255, 1)',
        textTransform: 'none',
        cursor: 'pointer',
        padding: '6px 16px',
        fontSize: '0.875rem',
        boxSizing: 'border-box',
        fontWeight: '500',
        lineHeight: '1.75',
        borderRadius: '4px',
        width: '100%',
        textAlign: 'center'
    },
    blueText: {
        color: theme.palette.primary.main,
        cursor: 'pointer',
        fontSize: '600'
    }
}));
export default function FileUpload(props) {
    const { register, errors, handleSubmit, setValue } = useForm({
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });
    const covrServicesUrl = process.env.REACT_APP_COVR_SERVICES_URL;
    const isLedgerRequested = props.fullFormState.pages.inforceLedger.inForceLedgerType === "inforceLedgerRequest"?true:false;

    const defaultFileState = {
        fileList: [],
        key: [],
        filesLoading: false,
        selectedFileDetails: null,
        updateFileTable: false,
        itemsPerPage: 10,
        nextPageMax: 5,
        pageNumber: 1,
        totalPages: 0,
        pageAddVisible: true,
        pageSubtractVisible: false,
        fileDetailsLoading: false,
        showCaseDetailsView: false,
        selectedCaseDetails: null,
    };
    const [fileState, updateFileState] = useState(defaultFileState);
    const [fileData, setFileData] = useState([]);
    const [postingApp, setPosting] = useState(false)
    const inputFile = useRef(null);

    const [error, displayError] = useState("");
    const handleValueChange = (field, value) => {
        setValue(field, value);
        props.onFieldChange(field, value);
    };

    useEffect(()=>{
        handleValueChange('file',fileState)
    },[fileState])

    useEffect(() => {

        register({ name: 'file' });
        setValue('file', props.formState.file);

        register({ name: 'uploadAs' });
        setValue('uploadAs', props.formState.quoteType);

    }, [register]);

    const removeFile = (value) => {
        let newFileState = fileState;
        let arrayOfFiles = fileState.fileList;
        let dataToRemove = fileData;
        const index = arrayOfFiles.indexOf(value);
        if (index > -1) {
            arrayOfFiles.splice(index, 1);
            dataToRemove.splice(index, 1);
        }
        setFileData([...dataToRemove]);
        newFileState.fileList = arrayOfFiles;
        updateFileState({ ...newFileState });
        displayError("");
    }

    useEffect(() => {

        const filesFromSession =  props.formState.file || null;
        updateFileState({
            ...fileState,
            fileList: filesFromSession !== null ? filesFromSession.fileList : [],
            casesLoading: false,
            pageLoading: false,
            updateCaseTable: false
        });

    }, [fileState.updateFileTable]);

    const fileSelectedHandler = async (event) => {
        if (event.target.files[0] === undefined) {
            setPosting(false);
            event.target.value="";
            return;
        }

        let fileSize = event.target.files[0].size;
        let fileName = event.target.files[0].name;
        let sameName = false;
        fileState.fileList.forEach((element, index) => {
            if (element.FileName === fileName) {
                sameName = true;
            }
        })

        if (sameName) {
            displayError("Same file upload is not allowed.");
            event.target.value="";
            return;
        }
        let acceptedExtension = ["pdf", "jpg", "tif"];
        let extension = fileName.split('.').pop();

        if (Number(fileSize) > 20971520) {
            displayError("File with maximum size of 20MB can be uploaded.");
            event.target.value="";
            return;
        }
        if (!acceptedExtension.includes(extension.toLowerCase())) {
            displayError("Only files with extensions .pdf, .tif, .jpg are allowed.");
            event.target.value="";
            return;
        }
        if(fileState.fileList.filter(x => x.FileType === "Ledger").length === 1 && props.formState.uploadAs === "Ledger") {
            displayError(`${isLedgerRequested ? "Signed In-Force Ledger Request document":"In-Force Ledger document"} can not be upload more than once.`);
            event.target.value = "";
            return;
        }
        if(fileState.fileList.filter(x => x.FileType === "AdditionalFile").length === 2 && props.formState.uploadAs === "AdditionalFile") {
            displayError("Maximum 2 additional documents can be uploaded.");
            event.target.value = "";
            return;
        }
        let type = props.formState.uploadAs;
        const dateTime  = format(new Date(), "MM/dd/yyyy hh:mm a");
        let fileList = {
            FileName : fileName,
            FileKey : null,
            CreatedDate : dateTime,
            FileType : type,
        }
        let newFileState = fileState;
        let arrayOfFiles = fileState.fileList;
        arrayOfFiles.push(fileList);
        newFileState.fileList = arrayOfFiles;
        updateFileState({ ...newFileState });
        displayError("");
        const file = event.target.files[0];

        new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (event) => {
                resolve(event.target.result);
            };

            reader.onerror = (err) => {
                reject(err);
            };

            reader.readAsDataURL(file);
        }).then((data) => {
            let arrayOfData = fileData;

            if (fileState.fileList.length > arrayOfData.length) {
                const nullArray = fileState.fileList.length - arrayOfData.length
                for (var i = 1; i < nullArray; i++) {
                    arrayOfData.push(null);
                }
            }
            arrayOfData.push(data);
            setFileData([...arrayOfData]);

        });
        event.target.value="";
    }

    const handleModalOpen = () => {      
            inputFile.current.click();
    }

     const handleOnSubmit = async () => {
            if (fileState.fileList.filter(x => x.FileType === "Ledger").length === 0) {
                setPosting(false);
                displayError(`Please upload ${isLedgerRequested ? "the signed In-Force Ledger Request document":"your In-Force Ledger document"}.`);
                return;
            }
        setPosting(true);
        displayError("");
        let body = [];
        fileState.fileList.forEach((element, i) => {
            let dataToPush
            if (element.versions) {
                dataToPush = {
                    FileName: element.versions[0].fileName,
                    FileKey: element.versions[0].fileID,
                    Data: null,
                    CreatedDate: element.dateTime
                }
            } else {
                dataToPush = {
                    FileKey: element.FileKey,
                    FileName: element.FileName,
                    Data: (element.FileKey && element.FileKey === null) ? null : fileData[i],
                    CreatedDate: element.CreatedDate,
                    FileType : element.FileType,
                }
            }
            body.push(dataToPush);
        });

        let newFileState = fileState;
        let array = [];
        let apiError = [];
        for (var i = 0; i < body.length; i++) {
            await httpRequest.post(`${covrServicesUrl}/api/MorganStanley/FilesUpload`, [body[i]])
                .then((data) => {
                    data.filedata.forEach(element => {
                        fileState.fileList.forEach((index, i) => {

                            if (index.FileName === element.fileName || (index.versions && index.versions[0].fileName === element.fileName) && element.fileKey !== null) {

                                let fileWithKey = newFileState.fileList[i];
                                fileWithKey.FileKey = element.fileKey;
                                fileWithKey.CreatedDate = element.createdDate;
                                newFileState.fileList[i] = fileWithKey;
                            }

                        })
                    });

                    if (!data.success) {
                        apiError.push(data.message + '<br/>')
                    }
                }).catch((error) => {
                    setPosting(false);
                })
        }
        if(apiError.length!==0)
        {
            displayError(apiError.toString());
            setPosting(false);
        }
        if(error ==='' && apiError.length === 0)
        {
            newFileState.fileList.forEach((index, i) => {
                if (index.FileKey !== null) {
                    array.push(index);
                }

            })
            setPosting(false)
            newFileState.fileList = array;
            updateFileState({ ...newFileState })
            props.onNext();
        }
    }

    const classes = useStyles();
    return (
        <Container fluid className='border-class'>
            <Form onSubmit={handleSubmit(handleOnSubmit)}>
                <Row className="justify-content-center pt-4 file-coverage">
                    <Col lg={8}>
                      <TitleComponent icon={FileDownload} title="Upload Attachments" />
                        <p className='mb-0 mt-1 stat-title-grey'>{`Please upload ${isLedgerRequested ? "the signed In-Force Ledger Request document":"your In-Force Ledger document"} and Additional Files (Quotes, Illustrations, etc) below. (Valid file types are PDF / TIF / JPG, the maximum file size is 20 megabytes)`}</p>
                    </Col>
                </Row>
                 <React.Fragment><Row>
                 <Col sm={{ span: 4, offset: 2 }} className='pr-0 mt-4'>
                        <Form.Group>
                            <SelectInput
                                name="uploadAs"
                                id="uploadAs"
                                value={props.formState.uploadAs}
                                onChange={(e) => handleValueChange('uploadAs', e.target.value)}
                                label="Upload File As"
                                selectOptions={[{ value: 'Ledger', label: isLedgerRequested ? 'In-Force Ledger Request Document':'In-Force Ledger Document' }, { value: 'AdditionalFile', label: 'Additional Files (Quotes, Illustrations, etc)' }]}
                                errors={errors.uploadAs}
                                inputRef={register}

                            />
                        </Form.Group>
                    </Col>
                    <Col sm={2}>
                        <div className='mt-4 pt-2'>
                        <label className={props.formState.uploadAs === '' || postingApp ? classes.disabledButtonSelect : classes.buttonSelect} disabled={props.formState.uploadAs === '' || postingApp ? true : false} onClick={() => handleModalOpen()}>SELECT FILE</label>
                            <input
                                id="file"
                                name="file"
                                style={{ display: 'none' }}
                                type={"file"}
                                ref={inputFile}
                                onChange={fileSelectedHandler}
                                disabled={props.formState.uploadAs === '' || postingApp ? true : false}
                                errors={errors.file}
                            />
                        </div>
                    </Col>
                </Row>
                    <Row className='justify-content-center mb-3 px-5'>
                        <div className='errorMessageCustom' dangerouslySetInnerHTML={{ __html: error }}></div>
                    </Row>
                    <Row>
                        <Col sm={{ span: 8, offset: 2 }}>
                            <FileTable
                                state={fileState}
                                stateUpdate={updateFileState}
                                fileData={fileData}
                                postingApp={postingApp}
                                removeFile={(value) => removeFile(value)}
                                setPosting = {(bool)=>setPosting(bool)}
                                isPermReview = {true}
                                isRequestedLedger={isLedgerRequested}
                            />
                        </Col>
                    </Row>
                        <BackNextButton onBack={props.onBack} continueLabel='NEXT' disabled={postingApp} />
                </React.Fragment>

            </Form>
        </Container >
    );
}

FileUpload.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func.isRequired,
    onFieldChange: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
};

FileUpload.DefaultFormState = (prefill) => {
    return {
        file: '',
        uploadAs:'Ledger',
    };
};

FileUpload.ValidationSchema = () => {
    return object().shape({
        uploadAs: string().required("This Field is required."),
    });
};






// WEBPACK FOOTER //
// ./src/components/PolicyReview/PermReview/steps/FileUpload.js